import React from "react"
import { createRequest } from "utils/request-helper"
import { withRouter } from "react-router-dom"
import {
  TableBody,
  TableContainer,
  TableHeader,
  TableHeaderCell,
  TableRow,
  TableRowCell,
} from "containers/Table"
import { ArchiveRequest } from "./index"

export class UserInfoRequestsLoaded extends React.Component {
  constructor(props) {
    super(props)
    this.archiveInfoRequest = this.archiveInfoRequest.bind(this)
    this.renderTableBody = this.renderTableBody.bind(this)
  }

  archiveInfoRequest(id) {
    if (window.confirm("Are you sure you want to archive this request?")) {
      createRequest(
        {
          method: "PATCH",
          route: `info_requests/${id}`,
          data: {
            data: {
              type: "info_requests",
              attributes: {
                archived: true,
              },
            },
          },
        },
        response => {
          if (response.status === 200) {
            this.props.history.push("/info_requests")
          }
        },
        error => console.error(error)
      )
    }
  }

  renderTableBody(data, included) {
    return (
      <TableBody>
        {data
          .filter(row => {
            return !row.attributes.archived
          })
          .map((row, i) => {
            let campId = row.relationships.camp.data.id
            let campAttributes = included.filter(camp => {
              return camp.type === "camps" && camp.id === campId
            })[0].attributes

            return (
              <TableRow key={i}>
                <TableRowCell>{campAttributes.name}</TableRowCell>
                <TableRowCell>
                  {campAttributes["camp-city"] +
                    ", " +
                    campAttributes["camp-state"]}
                </TableRowCell>
                <TableRowCell>
                  {campAttributes["description-brief-campers"]}
                </TableRowCell>
                <TableRowCell>
                  <ArchiveRequest
                    onClick={() => this.archiveInfoRequest(row.id)}
                  >
                    Cancel Request
                  </ArchiveRequest>
                </TableRowCell>
              </TableRow>
            )
          })}
      </TableBody>
    )
  }

  render() {
    const data = this.props.data.data
    const included = this.props.data.included

    return (
      <TableContainer>
        <TableHeader>
          <TableHeaderCell>Camp Name</TableHeaderCell>
          <TableHeaderCell>City & State</TableHeaderCell>
          <TableHeaderCell>Description</TableHeaderCell>
          <TableHeaderCell>Archive?</TableHeaderCell>
        </TableHeader>

        {this.renderTableBody(data, included)}
      </TableContainer>
    )
  }
}

export default withRouter(UserInfoRequestsLoaded)



// WEBPACK FOOTER //
// ./src/scenes/User/UserInfoRequests/UserInfoRequests.js